import { AuditTaskStatus } from "../../models/audit";
import { IValue } from "../../models/common/models.type";
import { IBasePagingRes } from "../models/common/model.type";

const STATUS_OPTIONS: IValue[] = [
  { title: "Common.Active", value: true },
  { title: "Common.Deactive", value: false }
];

const AUDIT_STATUS_OPTIONS: IValue[] = [
  { title: "Waiting", value: AuditTaskStatus.Waiting },
  { title: "Running", value: AuditTaskStatus.Running },
  { title: "Done", value: AuditTaskStatus.Done },
  { title: "Cancelled", value: AuditTaskStatus.Cancelled },
  { title: "Error", value: AuditTaskStatus.Error }
];

export const DEFAULT_BASE_PAGING_RES: IBasePagingRes<any> = {
  items: [],
  page: 1,
  pageSize: 0,
  total: 0,
  isFull: true
};

const VALUE_LIST = {
  STATUS_OPTIONS,
  AUDIT_STATUS_OPTIONS
};

export const firebaseConfig = {
  apiKey: "AIzaSyA6hDf9z0SIqVD90WcS-G8I0BZR2P2vNTU",
  authDomain: "linkco-e44e2.firebaseapp.com",
  projectId: "linkco-e44e2",
  storageBucket: "linkco-e44e2.firebasestorage.app",
  messagingSenderId: "1026194184268",
  appId: "1:1026194184268:web:f9f9747b32b25c452cfce9",
  measurementId: "G-EBJM3QF5E0"
};

export default VALUE_LIST;
